export default function proxiedMessages(
  messages: Record<string, string>,
): Record<string, string> {
  return messages;
}
